import React, { useState } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from "recharts";
import { formatNumberWithCommas } from "../../utils/common";
import { DonutChartDataType } from "../pages/dashboard/DashBoard";

interface DonutChartPropType {
  hotspotData: DonutChartDataType[];
  dataType: "Asean" | "Thailand";
}

const fontSize = 12;
const fontFamily = "Noto Sans Thai";
const fontColor = "#323232";

const renderActiveShape = (props: any) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    value,
    name,
    totalValue,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g className="hotspot-donut">
      <text
        x={cx}
        y={cy - 15}
        dy={8}
        textAnchor="middle"
        fill={fontColor}
        fontFamily={fontFamily}
        fontSize={14}
      >
        {`รวม`}
      </text>
      <text
        x={cx}
        y={cy + 10}
        dy={8}
        textAnchor="middle"
        fill={fontColor}
        fontFamily={fontFamily}
        fontSize={16}
      >
        {`${formatNumberWithCommas(totalValue)} จุด`}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fontColor}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fontColor} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fontSize={fontSize}
        fontFamily={fontFamily}
        fill={fontColor}
      >{`${name}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fontSize={fontSize}
        fontFamily={fontFamily}
        fill={fontColor}
      >
        {`${formatNumberWithCommas(value)} จุด`}
      </text>
    </g>
  );
};

function HotspotInfoDonutChart({
  hotspotData,
  dataType = "Thailand",
}: DonutChartPropType) {
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = (_: any, index: number) => {
    setActiveIndex(index);
  };

  return (
    <div className="w-full h-[310px]">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={500} height={310}>
          <Pie
            activeIndex={hotspotData.map((_, index) => index)}
            activeShape={renderActiveShape}
            data={hotspotData}
            cx="50%"
            cy="45%"
            innerRadius={50}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            onMouseEnter={onPieEnter}
          >
            {hotspotData.map((_, index) => (
              <Cell key={`cell-${index}`} fill={_.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default HotspotInfoDonutChart;
